import { UserRoleEnum } from "@/api/user/models";
import type { ScheduleStageCounts } from "@/api/schedule/models";
import {
  artisticProductionScheduleColumns,
  photographyScheduleColumns,
  productionScheduleColumns,
  receptionScheduleColumns,
  scheduledScheduleColumns,
} from "@/components/features/schedule/ScheduleTable";

export type ScheduleStage = "scheduled" | "reception" | "photography" | "production" | "artistic-production";

export const scheduleStageDefinitions: Array<{ label: string; value: ScheduleStage }> = [
  { label: "Agendados", value: "scheduled" },
  { label: "Recepção", value: "reception" },
  { label: "Fotografia", value: "photography" },
  { label: "Produção", value: "production" },
  { label: "Produção artística", value: "artistic-production" },
];

export const backendStageByScheduleStage: Record<ScheduleStage, keyof ScheduleStageCounts> = {
  scheduled: "SCHEDULED",
  reception: "RECEPTION",
  photography: "PHOTOGRAPHY",
  production: "PRODUCTION",
  "artistic-production": "ART_PRODUCTION",
};

export const OPERATIONAL_SCHEDULE_STAGE_BY_ROLE: Partial<Record<UserRoleEnum, ScheduleStage>> = {
  [UserRoleEnum.PHOTOGRAPHER]: "photography",
  [UserRoleEnum.PRODUCER]: "production",
  [UserRoleEnum.ART_PRODUCER]: "artistic-production",
};

export const scheduleColumnsByStage = {
  scheduled: scheduledScheduleColumns,
  reception: receptionScheduleColumns,
  photography: photographyScheduleColumns,
  production: productionScheduleColumns,
  "artistic-production": artisticProductionScheduleColumns,
};
